import React from 'react';
import { QRGenerator } from '../components/qr/QRGenerator';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';

export const QRGeneratorPage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          QR Code Generator
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Create professional QR codes with custom designs, logos, and colors.
          Choose from multiple content types and download in various formats.
        </p>
      </div>

      <QRGenerator />

      {/* Tips Section */}
      <Card className="mt-8">
        <CardHeader>
          <CardTitle>Pro Tips for Better QR Codes</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-semibold mb-2">📏 Size & Distance</h3>
              <p className="text-sm text-muted-foreground">
                Larger QR codes can be scanned from greater distances. For print materials,
                use at least 2x2 inches (5x5 cm).
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">🎨 Logo Placement</h3>
              <p className="text-sm text-muted-foreground">
                Keep logos small and centered. Use high contrast colors and avoid
                covering more than 30% of the QR code area.
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">🔧 Error Correction</h3>
              <p className="text-sm text-muted-foreground">
                Higher error correction levels allow for more damage but create denser codes.
                Use "High" for logos, "Medium" for most cases.
              </p>
            </div>
            <div>
              <h3 className="font-semibold mb-2">📱 Testing</h3>
              <p className="text-sm text-muted-foreground">
                Always test your QR codes with different devices and apps before
                printing or sharing publicly.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
